import React, { useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "../sub-components/Laoder";
import logo from "../../Assets/logo.png";

export default function SignUp() {
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      password: Yup.string()
        .min(6, "Must be at least 6 characters")
        .required("Required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await register();
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    },
  });

  const register = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/signup`,
        {
          fullName: formik.values.fullName,
          email: formik.values.email,
          password: formik.values.password,
          role: "user",
        }
      );

      if (response.status === 201) {
        toast.success(response.data.message);
        navigate("/login");
      } else if (response.status === 409) {
        toast.error(response.data.message);
      }

      console.log("Registration successful", response.data);
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.message || "An error occurred.");
      } else {
        toast.error("Unable to reach the server. Please try again.");
      }
      throw error;
    }
  };

  return (
    <div className="login_bg_img flex justify-center items-center">
      <div className="w-screen h-screen flex justify-center items-center bg_blure">
        <div className="login_container w-[993px] h-[699px] flex items-center justify-center flex-col p-16">
          <div className="title flex items-center justify-center flex-col mt-[20px]">
            <img
              src={logo}
              onClick={() => {
                navigate("/");
              }}
              className="p-4 cursor-pointer"
              alt="logo"
            />
            <h1 className="text-center text-white text-4xl font-semibold mb-[12px]">
              Get Started
            </h1>
            <p className="text-center text-white text-base max-w-[360px]">
              Welcome to Uno - Let’s create your account
            </p>
          </div>

          <div className="details flex items-center justify-center mt-[40px]">
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <input
                  type="text"
                  id="fullName"
                  className="name bg-transparent focus:outline-none w-full py-2 px-3 light-white"
                  placeholder="Full Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fullName}
                />
                {formik.touched.fullName && formik.errors.fullName ? (
                  <div className="text-red-500 error-message">
                    {formik.errors.fullName}
                  </div>
                ) : null}
              </div>
              <div className="mb-4">
                <input
                  type="email"
                  id="email"
                  className="email bg-transparent focus:outline-none w-full py-2 px-3 light-white"
                  placeholder="Email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 error-message">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
              <div className="mb-4">
                <input
                  type="password"
                  id="password"
                  className="password bg-transparent focus:outline-none w-full py-2 px-3 light-white"
                  placeholder="Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500 error-message">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>
              <div className="mb-4">
                <input
                  type="password"
                  id="confirmPassword"
                  className="confirm-password bg-transparent focus:outline-none w-full py-2 px-3 light-white"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmPassword}
                />
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <div className="text-red-500 error-message">
                    {formik.errors.confirmPassword}
                  </div>
                ) : null}
              </div>

              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[24px] w-[398px] h-[44px]"
              >
                {isLoading ? <Loader isLoading={isLoading} /> : "Sign Up"}
              </button>
              <p className="text-md text-center text-white mt-4">
                Don’t have an account?&nbsp;
                <Link to="/login" className="font-bold cursor-pointer">
                  Login
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
